import { render, staticRenderFns } from "./ReporterUserBlock.vue?vue&type=template&id=418c94f2&scoped=true"
import script from "./ReporterUserBlock.vue?vue&type=script&lang=js"
export * from "./ReporterUserBlock.vue?vue&type=script&lang=js"
import style0 from "./ReporterUserBlock.vue?vue&type=style&index=0&id=418c94f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c94f2",
  null
  
)

export default component.exports